module.exports = __webpack_public_path__ + "static/media/[Audio]2010-07-18-6.52a7671e.md";